/**
 *  @class
 *  @function ShippingEstimator
 */
if (!customElements.get('shipping-estimator')) {
  class ShippingEstimator extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupCountries();
      this.submitButton = this.querySelector('[type="button"]');
      if (this.submitButton) {
        this.submitButton.addEventListener('click', this.estimateShipping.bind(this));
      }
      this.results = this.querySelector('.shipping-estimator--results');
    }

    async estimateShipping() {
      const zip = this.querySelector('.shipping-estimator-zip').value,
        country = this.querySelector('.shipping-estimator-country').value,
        province = this.querySelector('.shipping-estimator-province').value;

      this.submitButton.classList.add('loading');
      const response = await fetch(
        `${window.theme.routes.cart_url}/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
        {
          method: 'POST'
        }
      );
      if (response.ok) {
        const shippingRates = await this.getShippingRates(zip, country, province);
        this.formatShippingRates(shippingRates);
      } else {
        const jsonError = await response.json();
        this.formatError(jsonError);
      }
      this.submitButton.classList.remove('loading');
    }

    async getShippingRates(zip, country, province) {
      const response = await fetch(
        `${window.theme.routes.cart_url}/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
      );
      const responseText = await response.text();
      if (responseText === 'null') {
        return this.getShippingRates(zip, country, province);
      } else {
        return JSON.parse(responseText).shipping_rates;
      }
    }

    /**
     * Formata texto de prazo de entrega com base nos campos retornados pela API
     */
    formatDeliveryText(shippingRate) {
      // 1) delivery_days: [min, max] em dias
      if (Array.isArray(shippingRate.delivery_days) && shippingRate.delivery_days.length) {
        const min = Number(shippingRate.delivery_days[0]);
        const max = Number(
          shippingRate.delivery_days[1] !== undefined ? shippingRate.delivery_days[1] : shippingRate.delivery_days[0]
        );

        if (min && max && min !== max) {
          return `Em até ${max} dias úteis`;
        }
        if (min) {
          return `Em até ${min} dias úteis`;
        }
      }

      // 2) delivery_range: { min: '2025-11-10T...', max: '2025-11-15T...' }
      if (shippingRate.delivery_range && (shippingRate.delivery_range.min || shippingRate.delivery_range.max)) {
        const minDate = shippingRate.delivery_range.min ? new Date(shippingRate.delivery_range.min) : null;
        const maxDate = shippingRate.delivery_range.max ? new Date(shippingRate.delivery_range.max) : null;

        const fmt = (d) =>
          d.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit'
          });

        if (minDate && maxDate && minDate.getTime() !== maxDate.getTime()) {
          return `Entrega entre ${fmt(minDate)} e ${fmt(maxDate)}`;
        }
        if (minDate) {
          return `Entrega a partir de ${fmt(minDate)}`;
        }
        if (maxDate) {
          return `Entrega até ${fmt(maxDate)}`;
        }
      }

      // 3) delivery_date simples
      if (shippingRate.delivery_date) {
        const d = new Date(shippingRate.delivery_date);
        const dataFmt = d.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit'
        });
        return `Entrega prevista para ${dataFmt}`;
      }

      // Sem info de prazo
      return '';
    }

    formatShippingRates(shippingRates) {
      let formattedShippingRates = '',
        answer = '',
        format = window.theme.settings.money_with_currency_format || '${{amount}}';

      shippingRates.forEach((shippingRate) => {
        const name = shippingRate.presentment_name || shippingRate.name;
        const price = formatMoney(parseFloat(shippingRate.price) * 100, format);
        const deliveryText = this.formatDeliveryText(shippingRate);

        formattedShippingRates += `
          <li class="shipping-estimator__item">
            <div class="shipping-estimator__line">
              <div class="shipping-estimator__info">
                <div class="shipping-estimator__name">${name}</div>
                ${deliveryText ? `<div class="shipping-estimator__eta">${deliveryText}</div>` : ''}
              </div>
              <div class="shipping-estimator__price">${price}</div>
            </div>
          </li>
        `;
      });

      if (shippingRates.length === 0) {
        answer = window.theme.strings.shippingEstimatorNoResults;
      } else if (shippingRates.length === 1) {
        answer = window.theme.strings.shippingEstimatorOneResult;
      } else {
        answer = window.theme.strings.shippingEstimatorMultipleResults;
      }

      const html = `
        <p>${answer}</p>
        ${formattedShippingRates === '' ? '' : `<ul>${formattedShippingRates}</ul>`}
      `;
      this.results.innerHTML = '';
      this.results.insertAdjacentHTML('beforeend', html);
    }

    formatError(errors) {
      let formattedShippingRates = '';
      Object.keys(errors).forEach((errorKey) => {
        formattedShippingRates += `<li>${errorKey} ${errors[errorKey]}</li>`;
      });
      const html = `
        <p>${window.theme.strings.shippingEstimatorError}</p>
        <ul>${formattedShippingRates}</ul>
      `;
      this.results.innerHTML = '';
      this.results.insertAdjacentHTML('beforeend', html);
    }

    setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        let formId = this.dataset.formId;
        new Shopify.CountryProvinceSelector(
          `shipping-estimator-country-${formId}`,
          `shipping-estimator-province-${formId}`,
          {
            hideElement: `shipping-estimator-province-wrapper-${formId}`
          }
        );
      }
    }
  }

  customElements.define('shipping-estimator', ShippingEstimator);
}
